import type { WsFeedPreference } from "@storyboard/web-client";
import { store } from "@/store/store";
import type { FeedPreference } from "@/store/types";

export async function bulkUpsertFeedPreference(records: WsFeedPreference[]) {
  if (records.length === 0) return;
  const data = records.map(
    (r): FeedPreference => ({
      id: r.id,
      feedId: r.feedId,
      workspaceMembershipId: r.workspaceMembershipId,
      handsFreeNotificationPreference: r.handsFreeNotificationPreference ?? "none",
      pushNotificationPreference: r.pushNotificationPreference ?? "none",
      createdAt: r.createdAt ?? null,
      updatedAt: r.updatedAt ?? null,
    }),
  );
  // The old ON CONFLICT SET kept the first-seen createdAt.
  store.upsert("feedPreference", data, (existing, next) => ({
    ...next,
    createdAt: existing.createdAt,
  }));
}
